import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Tag } from "../Tag";

import { formatNumberWithCommas } from "@/utils/formatNumberWithCommas";
import { unixToJST } from "@/utils/time";
import CoinImg from "./img/coin.png";
import CorrectImg from "./img/correct.png";
import NotCorrectImg from "./img/not_correct.png";
import { ArrowSvg } from "./svg/arrow.svg";
import { CorrectSvg } from "./svg/correct.svg";
import { NotCorrectSvg } from "./svg/notCorrect.svg";

interface Props {
  title: string;
  tag: string;
  isCorrect: boolean;
  points: number;
  betAmount: number;
  winnings: number;
  ranking: number;
  expiredAt: number;
  rankingComponent?: React.ReactNode;
}

export const ResultCardListItem: React.FC<Props> = ({
  title,
  tag,
  isCorrect,
  points,
  betAmount,
  winnings,
  ranking,
  expiredAt,
  rankingComponent,
}) => {
  const expiredAtJST = unixToJST({ unix_milliseconds: expiredAt * 1000 });

  return (
    <Card>
      <div className="p-5">
        <div className="flex items-center justify-between gap-2">
          <Tag text={tag} />
          <div className="text-sm text-light-gray">{expiredAtJST} 終了</div>
        </div>
        <div className="text-xl font-bold my-2">{title}</div>
        <div className="flex items-center gap-2 justify-between">
          <div className="text-xl flex items-center gap-1">
            <div>{isCorrect ? <CorrectSvg /> : <NotCorrectSvg />}</div>
            YES
            <div className="font-bold">70%</div>
          </div>
          {isCorrect && <img src={CorrectImg} alt="正解" className="w-20 h-20" />}
          {!isCorrect && <img src={NotCorrectImg} alt="不正解" className="w-20 h-20" />}
        </div>

        <table className="w-full border border-[#B8EAE7] rounded-lg [border-collapse:separate] [border-spacing:0]">
          <thead>
            <tr className="bg-[#E5FFFE]">
              <th className="py-2 border-r border-[#B8EAE7]">ベット額</th>
              <th className="py-2 border-r border-[#B8EAE7]">獲得</th>
              <th className="py-2">ランキング報酬</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-center font-bold text-lg py-2 border-r border-[#B8EAE7]">
                {formatNumberWithCommas(betAmount.toString())} pt
              </td>
              <td className="text-center font-bold text-lg py-2 border-r border-[#B8EAE7]">
                +{formatNumberWithCommas(winnings.toString())} pt
              </td>
              <td className="text-center font-bold text-lg py-2">+{formatNumberWithCommas(ranking.toString())}円</td>
            </tr>
          </tbody>
        </table>
        {rankingComponent}
        <div className="flex items-center justify-between gap-2 pt-3">
          <div className="font-bold flex items-center gap-2">
            <img src={CoinImg} alt="" className="w-6 h-6" />
            {formatNumberWithCommas(points.toString())}pt
          </div>
          <div>
            <Link to="#" className="text-blue-500 font-bold flex items-center gap-1">
              ランキングを見る
              <div className="mt-1">
                <ArrowSvg />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </Card>
  );
};
